<template>
    <div>
        <base-title title="Voucher" subtitle="List Data Voucher" />
        <v-data-table :loading="loading" :headers="headers" :items="Vouchers.data" class="elevation-1" hide-default-footer>
            <template v-slot:[`item.is_active`]="{ item }">
                <v-chip x-small :color="getColor(item.is_active)" dark>
                    {{ item.is_active ? "Active" : "Inactive" }}
                </v-chip></template>
            <template v-slot:[`item.status`]="{ item }">
                <v-chip x-small color="success" dark  v-if="item.status == 'AVAILABLE'">
                    {{ item.status  }}
                </v-chip>
                <v-chip x-small color="error" v-else>
                    {{ item.status }}
                </v-chip>
            </template>
            <template v-slot:[`item.percentage`]="{ item }">
                <strong>{{ item.percentage }}%</strong>
            </template>
            <template v-slot:[`item.nominal`]="{ item }">
                <strong>{{ item.nominal | currency("", 0, { symbolOnLeft: false, }) }}</strong>
            </template>
            <template v-slot:no-data> No data </template>

            <template v-slot:[`item.actions`]="{ item }">
                <v-icon color="warning" class="mr-2" @click.stop="editItem(item)">
                    mdi-pencil-box-outline
                </v-icon>
            </template>

            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-text-field v-model="search.search" label="Search Data" outlined dense hide-details></v-text-field>
                    <v-btn small color="darkblue" class="white--text ma-2" @click.stop="searching">Submit <v-icon
                            right>mdi-magnify</v-icon></v-btn>
                    <v-btn small color="secondary" class="white--text mx-1" @click.stop="clear">Clear
                        <v-icon right>mdi-close-circle-multiple </v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialogForm" max-width="600px" persistent>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" small elevation="1" color="primary" class="ma-2 white--text"
                                @click="loader = 'loading3'">
                                Create
                                <v-icon right dark>mdi-plus-circle </v-icon>
                            </v-btn>
                        </template>
                        <v-form ref="form_data" v-model="form_valid" lazy-validation>
                            <v-card class="rounded-lg">
                                <v-card-text>
                                    <v-select v-model="form_data.branch_id" :items="branch" item-text="name" item-value="id"
                                        label="Branch" outlined dense v-if="(ROLE == 'Owner')"></v-select>
                                    <v-text-field v-model="form_data.code" label="Code" outlined dense :rules="rule_code">
                                    </v-text-field>
                                    <v-text-field type="number" v-model="form_data.nominal"
                                        :disabled="form_data.percentage != 0" label="Nominal" outlined dense>
                                    </v-text-field>
                                    <v-text-field type="number" v-model="form_data.percentage"
                                        :disabled="form_data.nominal != 0" label="Percentage" @change="changePercentage"
                                        outlined dense>
                                    </v-text-field>
                                    <v-text-field type="date" v-model="form_data.expired_at" label="Expired Date" outlined
                                        dense>
                                    </v-text-field>
                                    <v-switch dense v-model="form_data.is_active" label="USE">
                                    </v-switch>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn small color="error darken-1" @click.stop="closedialogForm">Cancel
                                        <v-icon right dark>mdi-close </v-icon>
                                    </v-btn>
                                    <v-btn small color="primary" class="ma-2 white--text" @click.stop="save"
                                        :loading="btnLoading" :disabled="!form_valid || btnLoading">
                                        Save
                                        <v-icon right dark>mdi-content-save </v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-dialog>
                </v-toolbar>
            </template>
        </v-data-table>
        <v-pagination v-model="currentPage" :length="lastPage" :total-visible="10" :disabled="disabled"></v-pagination>
    </div>
</template>
  
<script>
import { mapGetters, mapMutations } from "vuex";
import { datatableMixin } from "@/mixins/datatable.js";
import BaseTitle from "@/components/base/BaseTitle.vue";
export default {
    name: "Voucher",

    mixins: [datatableMixin],

    data: () => ({
        headers: [
            { text: "Code", value: "code" },
            { text: "Percentage", value: "percentage" },
            { text: "Nominal", value: "nominal" },
            { text: "Expired Date", value: "expired_at" },
            { text: "Status", value: "status" },
            { text: "Use", value: "is_active" },
            { text: "Actions", value: "actions", sortable: false, width: 100 },
        ],
        branch: [],
        form_data: {
            code: "",
            percentage: 0,
            nominal: 0,
            expired_at: new Date().toJSON().slice(0, 10),
            is_active: true,
            branch_id: "",
        },
        form_default: {
            code: "",
            percentage: 0,
            nominal: 0,
            expired_at: new Date().toJSON().slice(0, 10),
            is_active: true,
            branch_id: "",
        },

        search: {
            search: null,
        },

        disabled: false,
        loading: false,
        page: 1,

    }),

    created() {
        this.initialize();
        this.getBranch();
    },

    methods: {
        ...mapMutations("voucher", ["SET_VOUCHERS", "SET_CURRENT_PAGE"]),
        initialize: async function () {
            this.datatableLoading = true;
            // this.disabled = true;
            let params = {
                page: this.page,
                search: this.search.search,
            }
            await this.$axios
                .get("/master/vouchers", {
                    params: params,
                    headers: {
                        Authorization: this.$store.getters["auth/Token"],
                    },
                })
                .then(({ data }) => {
                    this.$store.commit("voucher/SET_VOUCHERS", data.voucher);
                    this.datatable = data.voucher.data;
                    this.datatableLoading = false;
                })
                .catch(() => {
                    this.datatableLoading = false;
                });
        },

        searching() {
            this.page = 1;
            this.initialize();
        },
        clear() {
            this.page = 1;
            this.search = {
                search: "",
            };
            this.initialize();
        },

        changePercentage() {
            if (this.form_data.percentage > 100) {
                this.form_data.percentage = 100;
            } else if (this.form_data.percentage <= 0) {
                this.form_data.percentage = 0;
            }
        },

        async getBranch() {
            await this.$axios
                .get("/master/branches", {
                    headers: {
                        Authorization: this.$store.getters["auth/Token"],
                    },
                })
                .then(({ data }) => {
                    this.branch = data.branch.data;
                });
        },

        save: async function () {
            if (this.$refs.form_data.validate()) {
                this.btnLoading = true;
                if (this.editedIndex > -1) {
                    await this.$axios
                        .post(
                            "/master/vouchers/" + this.form_data.id,
                            {
                                _method: "PUT",
                                code: this.form_data.code,
                                percentage: this.form_data.percentage,
                                nominal: this.form_data.nominal,
                                expired_at: this.form_data.expired_at,
                                is_active: this.form_data.is_active,
                            },
                            {
                                headers: {
                                    Authorization: this.$store.getters["auth/Token"],
                                },
                            }
                        )
                        .then(({ data }) => {
                            Object.assign(this.datatable[this.editedIndex], data.discount);
                            this.closedialogForm();
                            this.btnLoading = false;
                        })
                        .catch(() => {
                            this.btnLoading = false;
                        });
                } else {
                    await this.$axios
                        .post(
                            "/master/vouchers",
                            {
                                code: this.form_data.code,
                                percentage: this.form_data.percentage,
                                nominal: this.form_data.nominal,
                                expired_at: this.form_data.expired_at,
                                is_active: this.form_data.is_active,
                            },
                            {
                                headers: {
                                    Authorization: this.$store.getters["auth/Token"],
                                },
                            }
                        )
                        .then(({ data }) => {
                            this.datatable.push(data.voucher);
                            this.closedialogForm();
                            this.btnLoading = false;
                        })
                        .catch(() => {
                            this.btnLoading = false;
                        });
                }
            }
        },

        closedialogForm() {
            this.dialogForm = false;
            this.$router.go();
        }
    },

    watch: {
        currentPage(newValue) {
            this.page = newValue;
            this.initialize();
        },
    },
    computed: {
        form_title() {
            return this.editedIndex === -1 ? "Create Voucher" : "Edit Voucher";
        },

        ...mapGetters("auth", {
            ROLE: "Role",
        }),

        ...mapGetters("voucher", {
            Vouchers: "Vouchers",
        }),


        currentPage: {
            get() {
                return this.Vouchers.current_page;
            },
            set(val) {
                return this.$store.commit("voucher/SET_CURRENT_PAGE", val);
            },
        },
        lastPage: {
            get() {
                return this.Vouchers.last_page;
            },
        },
    },
    components: {
        BaseTitle,
    },
};
</script>